import { useEffect } from 'react';
import type Konva from 'konva';

export function useCanvasFrameToolActivation(input: {
  eventBus: { on: (eventName: string, handler: (payload: any) => void) => () => void };
  toolRegistry: any;
  stageRef: { current: Konva.Stage | null };
  layerRef: { current: Konva.Layer | null };
  canvasLogger: { error: (message: string, error?: unknown) => void };
}): void {
  const { eventBus, toolRegistry, stageRef, layerRef, canvasLogger } = input;

  // Listen to frame tool activation from bottom toolbar and activate legacy genogram frame tool
  useEffect(() => {
    const off = eventBus.on('frame:tool-activate', (_payload: any) => {
      try {
        if (stageRef.current && layerRef.current) {
          toolRegistry.updateContext({
            stage: stageRef.current,
            layer: layerRef.current,
          } as any);
        }
        toolRegistry.activateTool('genogram-frame');
        const container = stageRef.current?.container();
        if (container?.style) container.style.cursor = 'crosshair';
      } catch (e) {
        canvasLogger.error('Failed to activate genogram-frame tool', e);
      }
    });
    return () => off();
    // Preserve existing dependency list from the inline effect.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventBus, toolRegistry]);
}

